export default __webpack_public_path__ + "static/media/46t.e08c1fac.jpg";